import { render } from "./AccessProductsTable.vue?vue&type=template&id=236fcb4e&scoped=true"
import script from "./AccessProductsTable.vue?vue&type=script&lang=js"
export * from "./AccessProductsTable.vue?vue&type=script&lang=js"

import "./AccessProductsTable.vue?vue&type=style&index=0&id=236fcb4e&lang=sass"
import "./AccessProductsTable.vue?vue&type=style&index=1&id=236fcb4e&lang=sass"
import "./AccessProductsTable.vue?vue&type=style&index=2&id=236fcb4e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-236fcb4e"]])

export default __exports__
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import QSpinnerGears from 'quasar/src/components/spinner/QSpinnerGears.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QExpansionItem,QSpinnerGears,QTable,QTr,QTd,QIcon,QTooltip,QBtn});
